import { Link } from 'react-router-dom'

type WorkflowCloseoutCardProps = {
  loadId: string
  loadStatus?: string | null
  jobId?: string | null
  jobStatus?: string | null
  podUploaded?: boolean
  invoiceId?: string | null
  invoiceStatus?: string | null
  tripStatus?: string | null
}

function stateLabel(value: boolean | string | null | undefined) {
  if (typeof value === 'boolean') return value ? 'Complete' : 'Pending'
  return value || 'Pending'
}

export default function WorkflowCloseoutCard({
  loadId, loadStatus, jobId, jobStatus, podUploaded, invoiceId, invoiceStatus, tripStatus,
}: WorkflowCloseoutCardProps) {
  const terminal = ['DELIVERED', 'COMPLETED', 'PAID'].includes(String(loadStatus ?? '').toUpperCase())
    || ['COMPLETED', 'PAID'].includes(String(jobStatus ?? '').toUpperCase())
    || ['COMPLETED', 'DELIVERED'].includes(String(tripStatus ?? '').toUpperCase())

  return (
    <section className="rounded-xl border bg-white p-5 space-y-4" aria-labelledby="workflow-closeout-heading">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h2 id="workflow-closeout-heading" className="font-semibold text-gray-800">{terminal ? 'Trip Complete' : 'Closeout &amp; handoff'}</h2>
          <p className="mt-1 text-sm text-gray-500">{terminal ? 'This transport is complete. Review history, evidence, and billing below.' : 'Keep operations, evidence, and billing connected through delivery.'}</p>
        </div>
        <span className={`rounded-full border px-2 py-1 text-xs font-semibold ${terminal ? 'border-emerald-200 bg-emerald-50 text-emerald-700' : 'border-amber-200 bg-amber-50 text-amber-700'}`}>
          {terminal ? 'Trip Complete' : 'In progress'}
        </span>
      </div>
      <div className="grid gap-2 text-sm sm:grid-cols-2 lg:grid-cols-4">
        <div className="rounded-lg border bg-gray-50 p-3"><span className="block text-xs text-gray-400">Trip</span><span className="font-medium">{stateLabel(tripStatus)}</span></div>
        <div className="rounded-lg border bg-gray-50 p-3"><span className="block text-xs text-gray-400">Delivery / job</span><span className="font-medium">{stateLabel(jobStatus)}</span></div>
        <div className="rounded-lg border bg-gray-50 p-3"><span className="block text-xs text-gray-400">Proof of delivery</span><span className="font-medium">{stateLabel(podUploaded)}</span></div>
        <div className="rounded-lg border bg-gray-50 p-3"><span className="block text-xs text-gray-400">Billing handoff</span><span className="font-medium">{stateLabel(invoiceStatus)}</span></div>
      </div>
      <div className="flex flex-wrap gap-2 text-sm">
        {jobId ? (
          <Link to={`/jobs/${jobId}/dispatch-sheet`} className="rounded-lg border border-slate-300 px-3 py-2 text-slate-700 hover:bg-slate-50">Document pack</Link>
        ) : (
          <Link to={`/loads/${loadId}/rate-confirmation`} className="rounded-lg border border-slate-300 px-3 py-2 text-slate-700 hover:bg-slate-50">Document pack</Link>
        )}
        {jobId && <Link to={`/jobs/${jobId}/pod`} className="rounded-lg border border-blue-300 px-3 py-2 text-blue-700 hover:bg-blue-50">POD &amp; evidence</Link>}
        {invoiceId && <Link to={`/invoices/${invoiceId}`} className="rounded-lg border border-indigo-300 px-3 py-2 text-indigo-700 hover:bg-indigo-50">Billing record</Link>}
          <Link to={'/loads/' + loadId} className="rounded-lg border border-gray-300 px-3 py-2 text-gray-700 hover:bg-gray-50">Open load history</Link>
      </div>
    </section>
  )
}
